import { render, staticRenderFns } from "./WizardQuestion.vue?vue&type=template&id=a4a8a694&scoped=true"
import script from "./WizardQuestion.vue?vue&type=script&lang=js"
export * from "./WizardQuestion.vue?vue&type=script&lang=js"
import style0 from "./WizardQuestion.vue?vue&type=style&index=0&id=a4a8a694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a8a694",
  null
  
)

export default component.exports